export type KiloPlan = 'free' | 'pro' | 'pro_plus'
export type CheckoutPlan = 'pro' | 'pro_plus'
export type { BillingInterval } from './billingInterval'
export { parseBillingInterval } from './billingInterval'

export function normalizeKiloPlan(raw: string | null | undefined): KiloPlan {
  const value = (raw ?? 'free').trim().toUpperCase().replace(/[\s-]+/g, '_')
  if (value === 'PRO_PLUS' || value === 'PROPLUS' || value === 'PREMIUM') return 'pro_plus'
  if (value === 'PRO') return 'pro'
  return 'free'
}

export function kiloPlanToCurrentTier(plan: KiloPlan): 'FREE' | 'PRO' | 'PRO_PLUS' {
  if (plan === 'pro_plus') return 'PRO_PLUS'
  if (plan === 'pro') return 'PRO'
  return 'FREE'
}

export function isPaidBillingStatus(status: string | null | undefined): boolean {
  const value = (status ?? 'free').toLowerCase()
  return value === 'premium' || value === 'trialing' || value === 'active' || value === 'past_due'
}

export function resolveEntitledPlan(
  currentTier: string | null | undefined,
  subscriptionStatus: string | null | undefined,
): KiloPlan {
  const plan = normalizeKiloPlan(currentTier)
  if (plan !== 'free') {
    return isPaidBillingStatus(subscriptionStatus) ? plan : 'free'
  }
  // Legacy rows: paid status with PREMIUM/current_tier unset → full bundle
  if (isPaidBillingStatus(subscriptionStatus)) return 'pro_plus'
  return 'free'
}

export function hasProAccess(plan: KiloPlan): boolean {
  return plan === 'pro' || plan === 'pro_plus'
}

export function hasProPlusAccess(plan: KiloPlan): boolean {
  return plan === 'pro_plus'
}
